<template>
  <div class="headbox menu_background_color">
    <!-- 顶部信息 -->
    <div
      class="indexwrapheadtitle container"
      :class=" indexmodule? 'indexmodule ':''"
    >
      <div class="titlemenu ">
        <a href="/" class="iconfont icon-menu menu_icon_color" @click.prevent.stop="showleftmenu" v-if="showmenu" ></a>
        <a href="/" class="iconfont icon-cancel-1-copy menu_icon_color" @click.prevent="hiddenleftmenu" v-else></a>
      </div>
      <div class="titleleft ">
        <a href="/" class="menu_icon_color">
          <img v-if="title_logo" :src="title_logo" :alt="title" @load="mainmenu.length&&hiddenmenu()" />
          <span v-else>{{title}}</span>
        </a>
      </div>
      <ul class="titleright ">
        <li>
          <a
            v-for="item in mainmenu"
            :key="item.ID"
            :href="item.path||item.url"
            class="secondary_title menu_icon_color"
            :class=" item.children.length? 'textnav has_child_menu':'textnav'"
          >
            {{item.title}}
            <i v-if="item.children.length" class="iconfont icon-sanjiaodown"></i>
            <ul v-if="item.children.length">
              <li style="height:10px" @click.prevent></li>
              <li v-for="subitem in item.children" :key="subitem.id">
                <a :href="subitem.path||subitem.url" class="secondary_title menu_icon_color">{{subitem.title}}</a>
              </li>
              <li style="height:10px" @click.prevent></li>
            </ul>
          </a>
        </li>
        <li v-if="checkout_member_config!='guest'">
          <a href="/account" class="iconfont icon-customer menu_icon_color">
            <span class="fallback-text">account</span>
          </a>
        </li>
        <li>
          <a href="/search" class="iconfont icon-search menu_icon_color" @click.prevent="showMasked">
            <span class="fallback-text">search</span>
          </a>
        </li>
        <li v-if="cart_type =='drawer'">
          <a
            href="/cart"
            class="iconfont icon-24gf-cart7 menu_icon_color"
            @click.prevent="showCart"
            style="font-weight:600;"
          >
            <span class="fallback-text">cart</span>
            <!--页面刷新时会传入购物车数量，vuex里的值默认为是为真的，所以一般情况下第一个值就觉得是否显示。只有当购物车页面使用api删除购物车的商品时才会使vuex里的值可能为假 -->
            <span v-if="cartContentsCount&&this.$store.state.cartContentsCount"></span>
          </a>
        </li>
        <li v-else>
          <a href="/cart" class="iconfont icon-24gf-cart7 menu_icon_color" style="font-weight:600;">
            <!--页面刷新时会传入购物车数量，vuex里的值默认为是为真的，所以一般情况下第一个值就觉得是否显示。只有当购物车页面使用api删除购物车的商品时才会使vuex里的值可能为假 -->
            <span v-if="cartContentsCount&&this.$store.state.cartContentsCount"></span>
            <span class="fallback-text">cart</span>
          </a>
        </li>
      </ul>
    </div>
    <!-- 搜索框 -->
    <transition>
      <div class="Masked" v-show="Masked" @click="hiddenMasked" @keyup.esc="hiddenMasked">
        <div class="searchinput">
          <i class="iconfont icon-cancel-1-copy"></i>
          <input
            ref="searchinput"
            type="text"
            :placeholder="$t('home.search_our_store')"
            v-model="search"
            @click.stop
            @keyup.enter="searchproducts()"
            autocomplete
            name="q"
          />
          <span class="iconfont" @click.stop="searchproducts">&#xe618;</span>
        </div>
      </div>
    </transition>
    <!-- 左边拉出抽屉 -->
    <div class="titlemenulist" :style="'top:-'+hasheader+'px'">
      <ul class="secondary_title">
        <!-- 主菜单栏 -->
        <li v-for="item in mainmenu" :key="'titlemenulist'+item.ID" class="titlemainmenu">
          <div>
            <a :href="item.path||item.url" @click.stop>{{item.title}}</a>
            <button
              v-if="item.children.length"
              class="iconfont icon-jia"
              @click.stop="secend_menu_switch"
            ></button>
          </div>
          <ul v-if="item.children.length" class="secend_menu_ul">
            <li
              v-for="subitem in item.children"
              :key="subitem.Id"
              class="titlemainmenu has_secend_menu"
            >
              <div>
                <a :href="subitem.path||subitem.url" @click.stop>{{subitem.title}}</a>
              </div>
            </li>
          </ul>
        </li>
        <!-- 登陆注册 -->
        <li v-if="checkout_member_config!='guest'">
          <div v-if="login_status">
            <a href="/account">{{$t('account.my_account')}}</a>
            <form id="logout-form" action="/logout" method="POST">
              <input type="hidden" name="_token" :value="token" />
              <a href="/" @click.prevent="logout">{{$t('account.log_out')}}</a>
            </form>
          </div>
          <div v-else>
            <a href="/account/login">{{$t('shopping.log_in')}}</a>
            <a href="/account/register">{{$t('login.create_account')}}</a>
          </div>
          <div></div>
        </li>
        <!-- 副菜单栏 -->
        <li v-for="item in secondary_menu" :key="item.ID">
          <a :href="item.path||item.url" @click.stop>{{item.title}}</a>
        </li>
      </ul>
    </div>
    <!-- 抽屉式购物车 -->
    <div v-if="cart_type=='drawer'" class="titlerightcart" ref="titlerightcart">
      <div class="cart_loading" v-if="cart_loading"></div>
      <div class="drawer_header">
        <h2>{{$t('cart.your_cart')}}</h2>
        <button class="iconfont icon-cancel-1-copy" @click="hiddenCart"></button>
      </div>
      <!-- <div class="drawer_inner" v-if="cart_product.length"> -->
      <div class="drawer_inner_main" v-if="cartmes.cart_contents_count">
        <div class="drawer_inner_main_item" v-for="item in cartmes.cart" :key="item.key">
          <div class="drawer_inner_main_item_left">
            <a :href="item.product.path||item.product.public_url">
              <img
                :src="item.variant?item.variant.feature_image?item.variant.feature_image.thumbnail:item.product.feature_image?item.product.feature_image.thumbnail:defaultImage:item.product.feature_image?item.product.feature_image.thumbnail:defaultImage"
                alt
                @error.once="imageFailure($event,defaultImage)"
              />
            </a>
          </div>
          <div class="drawer_inner_main_item_right">
            <p class="drawer_inner_main_item_right_name">
              <a :href="item.product.path||item.product.public_url">{{item.product.post_title}}</a>
            </p>
            <p class="drawer_inner_main_item_right_variant" v-if="item.variant">
              <template v-for="(subitem,subindex) in item.variant.attrs">
                <span v-if="subitem.value!='Default Title'" :key="subindex">{{subitem.value}}</span>
              </template>
            </p>
            <v-selectprice :price="item.line_subtotal-0"></v-selectprice>
            <div class="drawer_inner_main_item_right_price">
              <div>
                <el-input-number
                  v-model="item.quantity"
                  :min="0"
                  :max="100000"
                  :precision="0"
                  :step="1" step-strictly
                  size="mini"
                  @change="changequantity($event,item.key)"
                  :disabled="disabled_num"
                ></el-input-number>
              </div>
              <div
                class="iconfont"
                @click="changequantity(0,item.key)"
                style="fontSize:12px;lineHeight: 24px;cursor:pointer;"
              >&#xe61a;</div>
            </div>
          </div>
        </div>
        <!-- <div class="currency-tips" v-show="this.$store.state.pricetype !== cartmes.currency">
          All orders are processed in
          <span
            class="payment-currency"
          >{{this.$store.state.currentcountry}}</span>.
          While the content of your cart is currently displayed in
          <span
            class="display-currency"
          >{{this.$store.state.pricetype}}</span>,
          you will checkout using
          <span
            class="payment-currency"
          >{{this.$store.state.currentcountry}}</span>
          at the most current exchange rate.
        </div>-->
      </div>

      <div class="drawer_inner_foot" v-if="cartmes.cart_contents_count">
        <div
          class="drawer_inner_foot_price"
          v-if="cartmes.discount_cart"
        >
          <p class="iconfont">&#xe718; {{Object.values(cartmes.coupons)[0].description?Object.values(cartmes.coupons)[0].description:Object.values(cartmes.coupons)[0].code}}</p>
          <p>
            -
            <v-selectprice :price="cartmes.discount_cart"></v-selectprice>
          </p>
        </div>
        <div class="drawer_inner_foot_price">
          <p>{{$t('cart.subtotal')}}</p>
          <p>
            <v-selectprice :price="complete_subtotal"></v-selectprice>
          </p>
        </div>
        <!-- <div class="drawer_inner_foot_info">Shipping, taxes, and discounts calculated at checkout.</div> -->
        <button
          class="checkout secondary_title main_button"
          :class="{'button_active':checkout_active}"
          :disabled="checkout_active"
          @click="checkout"
          type="button"
        >{{$t('cart.check_out')}} →</button>
        <!-- </div> -->
      </div>
      <div v-else style="margin-top:15px;">{{$t('cart.cart_empty')}}</div>
    </div>
  </div>
</template>
<script>
import defaultImage from "./../../../../public/images/no-image.gif";
import API from "../../API";
import BScroll from "better-scroll";
export default {
  props: [
    "indexmodule",
    "login_status",
    "title",
    "cart",
    "hasheader",
    "checkout_member_config",
    "mainmenu",
    "secondary_menu",
    "pixel",
    "cart_type",
    "title_logo",
    "pixel_conversion",
  ],
  data() {
    return {
      Masked: false, //遮罩层的显示
      search: "", //搜索商品
      showmenu: true,
      token: document.head.querySelector('meta[name="csrf-token"]').content,
      isLogin: "",
      cartContentsCount: false,
      titleleftwidth: 0,
      titlerightwidth: 0,
      titlewidth: 0,
      checkout_active: false,
      // cart_product: [],
      // cart_subtotal: 0,
      defaultImage,
      cart_loading: false,
      disabled_num: false,
      // cart_contents_count: 0,
      cartmes: {}, //购物车信息
    };
  },
  methods: {
     checkout() {
      let cart_hash=  this.getCookie('cart_hash');
      this.checkout_active = true;
      let cart_item = Object.values(this.cartmes.cart);
      let content_ids = [];
      let product_category_ids = [];
      cart_item.forEach((item) => {
        content_ids.push(item.product_id);
        if (item.category_ids) {
          product_category_ids = product_category_ids.concat(item.category_ids);
        }
      });
      if (window.fbq) {
        if (
          this.pixel_conversion &&
          this.pixel_conversion.pixel_conversion &&
          this.pixel_conversion.pixel_conversion.length &&
          product_category_ids.length
        ) {
          this.initFBevent(
            this.pixel_conversion.pixel_conversion,
            product_category_ids
          );
        }
        window.fbq("track", "InitiateCheckout", {
          content_type: "product_group",
          content_ids,
          value: this.cartmes.cart_total,
          num_items: this.cartmes.cart_contents_count,
          currency: this.cartmes.currency ? this.cartmes.currency : "USD",
        });
      }
      this.$axios.post(API.statis_event, {
        name: "cart.check",
        parameters: { url: window.location.href },
      });
      if (window.gtag) {
     window.gtag("event", "cart.check");
      }
      setTimeout(() => {
        this.checkout_active = false;
      }, 3000);
      this.toCheckInfo(cart_hash);
      // window.open(`/checkouts/${cart_hash}`, "_self");
    },
    async changequantity(e, key) {
      try {
        this.disabled_num = true;
        var res = await this.$axios.put(API.changequantity + key, {
          quantity: e,
        });
        this.$store.dispatch("change_news_cart", res.data);
        this.cartmes = res.data;
        // this.cart_product = Object.values(res.data.cart);
        // this.cart_subtotal = res.data.cart_subtotal;
        // this.cart_contents_count = res.data.cart_contents_count;
        this.cartContentsCount = res.data.cart_contents_count;
        this.$store.dispatch("cartContentsCount", res.data.cart_contents_count);
        localStorage.setItem("cartContentsCount", res.data.cart_contents_count);
        this.disabled_num = false;
      } catch (error) {
        this.disabled_num = false;
        this.$message.error(error.response.data.message);
      }
    },
    secend_menu_switch(e) {
      if (e.target.className.includes("icon-jian")) {
        this.$(e.target).removeClass("icon-jian");
        this.$(e.target).addClass("icon-jia");
      } else {
        this.$(e.target).removeClass("icon-jia");
        this.$(e.target).addClass("icon-jian");
      }
      this.$(e.target.parentNode.nextElementSibling).slideToggle(300);
    },
    async showCart(event) {
      document.body.addEventListener("click", this.hiddenCart, true);
      let right_width = this.$(window).width() > 590 ? "400px" : "300px";
      this.$("#app").animate({ right: right_width }, 300);
      this.$(".titlerightcart").animate({ right: "0px" }, 300);
      this.$("html,body").css({ overflowY: "hidden" });
      if (event) {
        this.cart_loading = true;
        try {
          let res = await this.$axios.get(API.addcart + "?" + Math.random());
          console.log(res);
          this.cartmes = res.data;
          console.log("cartmes.currency", this.cartmes);
          this.cartContentsCount = res.data.cart_contents_count;
          // this.cart_product = Object.values(res.data.cart);
          // this.cart_subtotal = res.data.cart_subtotal;
          // this.cart_contents_count = res.data.cart_contents_count;
        } catch (error) {
          if (
            error.response &&
            error.response.data &&
            error.response.data.message
          ) {
            this.$message.error(error.response.data.message);
          }
        }
        this.cart_loading = false;
      }
    },
    hiddenCart(event) {
      let window_width =
        this.$(window).width() > 590
          ? this.$(window).width()
          : this.$(window).width() + 100;
      if (
        event.target.className == "iconfont icon-cancel-1-copy" ||
        window_width - event.clientX > 400
      ) {
        event.stopPropagation();
        event.preventDefault();
        let right_width = this.$(window).width() > 590 ? "-400px" : "-300px";
        this.$("#app").animate({ right: "0" }, 400, () => {
          this.$("#app").removeAttr("style");
        });
        this.$(".titlerightcart").animate({ right: right_width }, 400);
        this.$("html,body").css({ overflowY: "visible" });
        this.$(".pricelist").css("display", "none");
        this.$store.dispatch("change_cart_type", false);
        this.cart_loading = false;
        document.body.removeEventListener("click", this.hiddenCart, true);
      }
    },
    showleftmenu() {
      this.showmenu = false;
      document.body.addEventListener("click", this.hiddenleftmenu, true);
      this.$("#app").animate({ left: "300px" }, 400);
      this.$("html,body").css({ overflowY: "hidden" });
      this.$(".titlemenulist").css({ overflow: "auto" });
    },
    hiddenleftmenu(event) {
      console.log(event);
      if (event.clientX > 300) {
        this.showmenu = true;
        event.stopPropagation();
        event.preventDefault();
        this.$("#app").animate({ left: "0" }, 300, () => {
          this.$("#app").removeAttr("style");
        });
        console.log(5959);
        this.$("html,body").css({ overflowY: "visible" });
        this.$(".pricelist").css("display", "none");
        document.body.removeEventListener("click", this.hiddenleftmenu, true);
      }
    },
    logout() {
      document.getElementById("logout-form").submit();
    },
    showMasked() {
      this.$("html,body").css({ overflowY: "hidden" });
      this.Masked = true;
      setTimeout(() => {
        this.$refs.searchinput.focus();
      }, 100);
    },
    hiddenMasked() {
      this.$("html,body").css({ overflowY: "visible" });
      this.Masked = false;
    },
    searchproducts() {
      if (window.fbq) {
        window.fbq("track", "Search", { search_string: this.search });
      }
      window.open("/search?q=" + encodeURIComponent(this.search), "_self");
    },
    hiddenmenu() {
      this.titlewidth = this.$(".indexwrapheadtitle").width();
      this.titleleftwidth =
        this.$(".titleleft").outerWidth(true) > this.titleleftwidth
          ? this.$(".titleleft").outerWidth(true)
          : this.titleleftwidth;
      this.titlerightwidth =
        this.$(".titleright ").outerWidth(true) > this.titlerightwidth
          ? this.$(".titleright ").outerWidth(true)
          : this.titlerightwidth;
      if (
        this.$(window).width() > 767 &&
        this.titlewidth - this.titlerightwidth - this.titleleftwidth < 20
      ) {
        console.log("小于20生效");
        this.$(".titlemenu").show();
        this.$(".titleright li:first").hide();
        this.$(".titleleft ").show();
        this.$(".titleleft a ").css({
          "font-weight": "normal",
          "font-size": "20px",
        });
      } else if (
        this.$(window).width() > 767 &&
        this.titlewidth - this.titlerightwidth - this.titleleftwidth > 20
      ) {
        console.log("大于20生效");

        this.$(".titlemenu").hide();
        this.$(".titleright li:first").css("display", "inline-block");
        this.$(".titleleft ").css("display", "inline-block");
        this.$(".titleleft a ").css({
          "font-weight": "600",
          "font-size": "25px",
        });
      }
    },
  },
  beforeMount() {
    if (
      !window.fbq &&
      this.pixel_conversion &&
      this.pixel_conversion.pixel_conversion
    ) {
      this.FBevent();
    }
  },
  mounted() {
    window.addEventListener(
      "pageshow",
      () => {
        this.checkout_active = false;
      },
      false
    );
    console.log("secondary_menu", this.secondary_menu);
    console.log("mainmenu", this.mainmenu);
    console.log("currentcountry", this.$store.state.currentcountry);

    if (this.mainmenu.length) {
      this.titleleftwidth = this.$(".titleleft").outerWidth(true);
      this.hiddenmenu();
      window.addEventListener(
        "resize",
        () => {
          this.hiddenmenu();
        },
        false
      );
    }
    //购物车如果有东西this.cart为false
    this.cartContentsCount = !this.cart;
  },
  watch: {
    "$store.state.cart_type"() {
      if (this.$store.state.cart_type) {
        this.cartContentsCount = 1;
        this.showCart(0);
      }
    },
    "$store.state.news_cart"() {
      console.log(this.$store.state.news_cart);
      this.cartmes = this.$store.state.news_cart;
    },
  },
  computed: {
    complete_subtotal() {
      let subtotal = this.cartmes.cart_total - this.cartmes.shipping_total;
      if (
        this.cartmes.fees &&
        this.cartmes.fees["shipping-insurance"] &&
        this.cartmes.fees["shipping-insurance"].amount
      ) {
        subtotal = subtotal - this.cartmes.fees["shipping-insurance"].amount;
      }
      return subtotal;
    },
  },
};
</script>
<style  lang='scss'>
.headbox {
  ul {
    padding: 0;
    li {
      list-style: none;
    }
  }
  .indexwrapheadtitle {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-top: 15px;
    padding-bottom: 15px;
    .titlemenu {
      display: none;
      width: 110px;
      float: left;
      -webkit-tap-highlight-color: rgba(23, 178, 235, 0.3) !important;
      a {
        color: black;
        text-decoration: none;
        font-weight: 600;
        font-style: normal;
        letter-spacing: 0.1em;
        font-size: 30px;
      }

      .icon-cancel-1-copy {
        font-size: 20px;
      }
    }
    .titleleft {
      display: inline-block;
      text-align: center;
      a {
        color: black;
        font-size: 25px;
        font-weight: 600;
        font-style: normal;
        letter-spacing: 0.1em;
        text-transform: uppercase;
        text-decoration: none;
        img {
          max-width: 180px;
        }
      }
    }

    .titleright {
      float: right;
      margin: 0;
      & > li:not(:first-child) {
        padding: 0;
        a {
          padding: 0 7.5px;
        }
      }
      & > li {
        float: left;
        margin: 0;
        padding: 0 7.5px;
        position: relative;
        line-height: 62px;
        .textnav {
          font-size: 14px;
          padding: 0 15px;
          position: relative;
        }
        .has_child_menu {
          ul {
            display: none;
            position: absolute;
            background: white;
            top: 58px;
            left: 0;
            min-width: 100%;
            z-index: 99999;
            box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.09);
            li {
              text-align: left;
              line-height: 35px;
              background: white;
              a {
                width: 100%;
                padding: 0 15px;
                letter-spacing: 0px;
                white-space: nowrap;
                color: black;
                font-size: 16px;
              }
            }
          }
          i {
            margin-left: 7.5px;
            color: black;
            font-size: 11px;
            line-height: 1;
            vertical-align: middle;
          }
          &:hover {
            background: white;
            &::before {
              content: "";
              position: absolute;
              left: 15px;
              right: 30px;
              bottom: 4px;
              display: block;
              background-color: #222323;
              height: 1px;
              z-index: 9999;
            }
            ul {
              display: block;
              &:hover {
                display: block;
              }
              li {
                &:hover {
                  a {
                    color: #a26b25;
                  }
                }
              }
            }
          }
        }

        a {
          display: inline-block;
          color: black;
          font-size: 20px;
          text-decoration: none;
          font-style: normal;
          letter-spacing: 2px;
          text-transform: uppercase;
        }

        span {
          position: absolute;
          width: 10px;
          height: 10px;
          border-radius: 50%;
          top: 20px;
          right: 5px;
          display: inline-block;
          background: #a26b25;
        }
      }
    }
  }
  .titlerightcart {
    width: 400px;
    height: 100%;
    background: #e8e8e8;
    position: fixed;
    top: 0;
    right: -400px;
    padding: 0 30px;
    display: flex;
    flex-direction: column;
    z-index: 9999;
    .cart_loading {
      display: block;
      width: 24px;
      height: 24px;
      position: absolute;
      left: 50%;
      top: 150px;
      margin-left: -12px;
      margin-top: -12px;
      border-radius: 50%;
      border: 3px solid #000;
      border-top-color: transparent;
      -webkit-animation: spin 1s infinite linear;
      -moz-animation: spin 1s infinite linear;
      -o-animation: spin 1s infinite linear;
      animation: spin 1s infinite linear;
      @-webkit-keyframes spin {
        0% {
          -webkit-transform: rotate(0deg);
          -moz-transform: rotate(0deg);
          -ms-transform: rotate(0deg);
          -o-transform: rotate(0deg);
          transform: rotate(0deg);
        }
        100% {
          -webkit-transform: rotate(360deg);
          -moz-transform: rotate(360deg);
          -ms-transform: rotate(360deg);
          -o-transform: rotate(360deg);
          transform: rotate(360deg);
        }
      }
      @-moz-keyframes spin {
        0% {
          -webkit-transform: rotate(0deg);
          -moz-transform: rotate(0deg);
          -ms-transform: rotate(0deg);
          -o-transform: rotate(0deg);
          transform: rotate(0deg);
        }
        100% {
          -webkit-transform: rotate(360deg);
          -moz-transform: rotate(360deg);
          -ms-transform: rotate(360deg);
          -o-transform: rotate(360deg);
          transform: rotate(360deg);
        }
      }
      @-ms-keyframes spin {
        0% {
          -webkit-transform: rotate(0deg);
          -moz-transform: rotate(0deg);
          -ms-transform: rotate(0deg);
          -o-transform: rotate(0deg);
          transform: rotate(0deg);
        }
        100% {
          -webkit-transform: rotate(360deg);
          -moz-transform: rotate(360deg);
          -ms-transform: rotate(360deg);
          -o-transform: rotate(360deg);
          transform: rotate(360deg);
        }
      }
      @keyframes spin {
        0% {
          -webkit-transform: rotate(0deg);
          -moz-transform: rotate(0deg);
          -ms-transform: rotate(0deg);
          -o-transform: rotate(0deg);
          transform: rotate(0deg);
        }
        100% {
          -webkit-transform: rotate(360deg);
          -moz-transform: rotate(360deg);
          -ms-transform: rotate(360deg);
          -o-transform: rotate(360deg);
          transform: rotate(360deg);
        }
      }
    }
    .drawer_header {
      width: 100%;
      height: 80px;
      justify-content: space-between;
      border-bottom: 1px solid #000;
      h2 {
        display: inline-block;
        line-height: 80px;
        font-size: 24px;
        margin: 0;
      }
      button {
        height: 100%;
        float: right;
        border: none;
        padding: 0 20px;
        background-color: transparent;
        font-size: 12px;
      }
    }
    // .drawer_inner {
    //   flex: 1;
    //   flex-direction: column;
    //   display: flex;
    .drawer_inner_main {
      flex: 1;
      margin-right: -30px;
      padding-right: 30px;
      // height: calc(100vh - 269px);
      overflow-y: auto;
      .currency-tips {
        color: rgba(0, 0, 0, 0.65);
        border: 1px solid #ffe58f;
        background-color: #fffbe6;
        padding: 8px 12px;
        margin-bottom: 12px;
      }
      .drawer_inner_main_item {
        margin-top: 30px;
        padding-bottom: 30px;
        // border-bottom: 1px solid #3a3a3a;
        .drawer_inner_main_item_left {
          display: inline-block;
          padding-left: 15px;
          margin-left: -15px;
          width: 25%;
          vertical-align: top;
          img {
            max-width: 100%;
          }
        }
        .drawer_inner_main_item_right {
          width: 75%;
          display: inline-block;
          padding-left: 12px;
          .drawer_inner_main_item_right_name {
            opacity: 0.9;
            a {
              line-height: 1;
              font-size: 17px;
              color: #3a3a3a;
              text-decoration: none;
            }
          }
          .drawer_inner_main_item_right_variant {
            opacity: 0.9;
            span {
              font-size: 15px;
              color: #3a3a3a;
            }
            & > span:not(:last-child)::after {
              content: " / ";
            }
          }
          p {
            margin-bottom: 0;
          }
          .drawer_inner_main_item_right_price {
            margin-top: 3px;
            display: flex;
            & > div {
              flex: 1;
            }
            div:last-child {
              text-align: right;
            }
            .el-input-number {
              width: 75px;
              line-height: 23px;
              height: 23px;
              .el-input-number__decrease,
              .el-input-number__increase {
                background-color: transparent !important;
                border-radius: 0;
                width: 23px;
                height: 22px;
                color: #3a3a3a !important;
                &:hover {
                  background-color: #000 !important;
                  i {
                    color: white;
                  }
                }
              }
              .el-input-number__decrease {
                border-right: 1px solid #000 !important;
              }
              .el-input-number__increase {
                border-left: 1px solid #000 !important;
              }
              .el-input {
                .el-input__inner {
                  background-color: transparent !important;
                  border-radius: 0;
                  border: 1px solid #000;
                  padding-left: 23px;
                  padding-right: 23px;
                  height: 23px;
                  line-height: 23px;
                  font-size: 13px;
                  font-weight: 600;
                }
              }
            }
          }
        }
        &:last-child {
          border-bottom: unset;
        }
      }
    }
    .drawer_inner_foot {
      // height: 158px;
      border-top: 1px solid #000;
      padding-top: 15px;
      color: #3a3a3a;
      padding-bottom: 30px;

      .drawer_inner_foot_price {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 15px;
        word-break: break-word;
        p{
          margin: 0;
          flex: 1;
        }
        p:first-child {
          font-size: 15px;
          margin: 0;
          font-weight: 600;
          font-style: normal;
          letter-spacing: 0.1em;
          text-transform: uppercase;
        }
        p:last-child {
          text-align: right;
        }
      }
      .drawer_inner_foot_info {
        text-align: center;
        font-size: 15px;
        color: #3a3a3a;
        margin-bottom: 15px;
        opacity: 0.7;
      }
      .checkout {
        width: 100%;
        display: inline-block;
        padding: 12px 20px;
        border: none;
        background: rgb(201, 13, 13) !important;
        color: white;
        font-weight: 600;
        font-style: normal;
        letter-spacing: 0.1em;
        text-transform: uppercase;
        font-size: 13px;
        border-radius: 0;
        cursor: pointer;
        &:hover {
          background: rgb(241, 34, 34) !important;
        }
      }
      .checkout_active {
        position: relative;
        color: rgb(201, 13, 13) !important;
        &::after {
          content: "";
          display: block;
          width: 24px;
          height: 24px;
          position: absolute;
          left: 50%;
          top: 50%;
          margin-left: -12px;
          margin-top: -12px;
          border-radius: 50%;
          border: 3px solid #fff;
          border-top-color: transparent;
          -webkit-animation: spin 1s infinite linear;
          -moz-animation: spin 1s infinite linear;
          -o-animation: spin 1s infinite linear;
          animation: spin 1s infinite linear;
          @-webkit-keyframes spin {
            0% {
              -webkit-transform: rotate(0deg);
              -moz-transform: rotate(0deg);
              -ms-transform: rotate(0deg);
              -o-transform: rotate(0deg);
              transform: rotate(0deg);
            }
            100% {
              -webkit-transform: rotate(360deg);
              -moz-transform: rotate(360deg);
              -ms-transform: rotate(360deg);
              -o-transform: rotate(360deg);
              transform: rotate(360deg);
            }
          }
          @-moz-keyframes spin {
            0% {
              -webkit-transform: rotate(0deg);
              -moz-transform: rotate(0deg);
              -ms-transform: rotate(0deg);
              -o-transform: rotate(0deg);
              transform: rotate(0deg);
            }
            100% {
              -webkit-transform: rotate(360deg);
              -moz-transform: rotate(360deg);
              -ms-transform: rotate(360deg);
              -o-transform: rotate(360deg);
              transform: rotate(360deg);
            }
          }
          @-ms-keyframes spin {
            0% {
              -webkit-transform: rotate(0deg);
              -moz-transform: rotate(0deg);
              -ms-transform: rotate(0deg);
              -o-transform: rotate(0deg);
              transform: rotate(0deg);
            }
            100% {
              -webkit-transform: rotate(360deg);
              -moz-transform: rotate(360deg);
              -ms-transform: rotate(360deg);
              -o-transform: rotate(360deg);
              transform: rotate(360deg);
            }
          }
          @keyframes spin {
            0% {
              -webkit-transform: rotate(0deg);
              -moz-transform: rotate(0deg);
              -ms-transform: rotate(0deg);
              -o-transform: rotate(0deg);
              transform: rotate(0deg);
            }
            100% {
              -webkit-transform: rotate(360deg);
              -moz-transform: rotate(360deg);
              -ms-transform: rotate(360deg);
              -o-transform: rotate(360deg);
              transform: rotate(360deg);
            }
          }
        }
        &:hover {
          background: rgb(201, 13, 13) !important;
        }
      }
    }
    // }
  }
  .titlemenulist {
    width: 300px;
    padding-top: 20px;
    height: 100vh;
    background: #e8e8e8;
    position: absolute;
    top: 0;
    left: -300px;
    padding-bottom: 100px;
    ul {
      width: 100%;
      .titlemainmenu {
        position: relative;
        div {
          display: flex;
          justify-content: space-between;
          align-items: center;
          a {
            flex: 1;
            padding: 15px;
            font-size: 22px;
          }
          button {
            padding: 15px;
            border: none;
            background: transparent;
          }
        }
        &::after {
          content: "";
          position: absolute;
          bottom: 0;
          left: 15px;
          right: 15px;
          border-bottom: 1px solid #343535;
        }
      }
      .secend_menu_ul {
        display: none;
        .has_secend_menu {
          div {
            a {
              padding-left: 30px;
            }
          }
          &::after {
            top: 0;
            bottom: unset;
          }
        }
      }

      li {
        width: 100%;
        box-sizing: border-box;
        text-align: left;
        a {
          width: 100%;
          display: inline-block;
          padding: 10px 15px;
          text-decoration: none;
          font-size: 16px;
          color: #3a3a3a;
        }
      }
    }
  }

  //首页head的样式
  .indexmodule {
    position: absolute !important;
    top: 0 !important;
    left: 50% !important;
    transform: translateX(-50%) !important;
    z-index: 999;
  }
}

.Masked {
  background: white;
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
  .searchinput {
    width: 300px;
    position: absolute;
    margin: auto;
    top: 40vh;
    bottom: 0;
    right: 0;
    left: 0;
    z-index: 20;
    display: flex;
    input {
      width: 10px;
      border: none;
      height: 45px;
      flex: 1;
      padding: 8px 10px;
      background: #f6f6f6;
      font-size: 18px;
    }
    span {
      text-align: center;
      width: 56px;
      height: 45px;
      line-height: 45px;
      background: #c90d0d;
      color: white;
      border: none;
      font-size: 12px;
      cursor: pointer;
    }
    i {
      position: fixed;
      right: 50px;
      top: 30px;
      font-weight: bolder;
      cursor: pointer;
    }
  }
}
.v-enter,
.v-leave-to {
  opacity: 0;
}
.v-enter-active,
.v-leave-active {
  transition: all 0.3s ease;
}

@media screen and (max-width: 767px) {
  .indexwrapheadtitle {
    .titlemenu {
      width: 40px !important;
      display: block !important;
    }

    .titleleft {
      display: inline-block;
      a {
        font-weight: normal !important;
        font-size: 20px !important;
        img{
          max-width: 65px !important;
        }
      }
    }

    .titleright {
      li:not(:last-child) {
        display: none !important;
      }

      .icon-gwc {
        font-size: 25px !important;
      }
    }
  }
}
@media screen and(max-width: 590px) {
  .titlerightcart {
    width: 300px !important;
    padding: 0 15px !important;
    right: -300px;
  }
}
</style>